import { IconProps } from "../../utils/global-types/global-types";

const SortByIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-5 h-5"}
      {...rest}
    >
      <g clipPath="url(#clip0_3803_58325)">
        <path
          fill="currentColor"
          d="M8.443 4.079 6.16 7.412A.8.8 0 0 0 6 7.85c0 .249.2.403.535.403h4.931c.334 0 .534-.154.534-.403a.8.8 0 0 0-.162-.436L9.557 4.08c-.147-.214-.345-.333-.557-.333s-.41.117-.557.332"
        ></path>
      </g>
      <g clipPath="url(#clip1_3803_58325)">
        <path
          fill="currentColor"
          d="M8.443 14.143 6.16 10.81A.8.8 0 0 1 6 10.374c0-.25.2-.404.535-.404h4.931c.334 0 .534.154.534.403 0 .129-.056.281-.162.436l-2.281 3.334c-.147.215-.345.333-.557.333s-.41-.117-.557-.332"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_3803_58325">
          <path fill="#fff" d="M6 9V3h6v6z"></path>
        </clipPath>
        <clipPath id="clip1_3803_58325">
          <path fill="#fff" d="M6 9.222v6h6v-6z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default SortByIcon;
